import { Box } from '@mui/material';

export default function RemoveGoogleChromeAutoFillBackground({ children }) {
  return (
    <Box
      sx={{
        'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active': {
          borderRadius: '0px',
          fontSize: 'inherit !important`',
          WebkitBoxShadow: ({ palette }) => `0 0 0 30px ${palette.background.paper} inset !important`,
        },
      }}
    >
      {children}
    </Box>
  );
}
